export default "__VITE_ASSET__0915f785__"